module.exports = __webpack_public_path__ + "static/media/hero-banner-people.9b0973c0.svg";